"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Youtube, Instagram, Twitter, Linkedin, Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
function FallbackMenu() {
  const columns = [{
    title: "Prodotti",
    links: [{
      label: "Sistemi di allarme",
      href: "/ShopPage"
    }, {
      label: "Sensori di movimento",
      href: "/ShopPage"
    }, {
      label: "Camere di videosorveglianza",
      href: "/ShopPage"
    }, {
      label: "Prese di rilevamento",
      href: "/ShopPage"
    }]
  }, {
    title: "Soluzioni",
    links: [{
      label: "Monitoraggio 24/7",
      href: "#"
    }, {
      label: "Installazione",
      href: "#"
    }, {
      label: "Assistenza tecnica",
      href: "#"
    }]
  }, {
    title: "Supporto",
    links: [{
      label: "Contatti",
      href: "#"
    }, {
      label: "FAQ",
      href: "#"
    }, {
      label: "Manuali e Guide",
      href: "#"
    }]
  }, {
    title: "Azienda",
    links: [{
      label: "Chi siamo",
      href: "#"
    }, {
      label: "Lavora con noi",
      href: "#"
    }, {
      label: "Blog",
      href: "#"
    }]
  }, {
    title: "Legale",
    links: [{
      label: "Crea-kit",
      href: "/crea-kit"
    }, {
      label: "Privacy Policy",
      href: "/PrivacyPolicyPage"
    }, {
      label: "Politica di Rimborso",
      href: "/RefundAndReturnPolicyPage"
    }]
  }];
  return <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-12">
      {columns.map((col, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
          <h3 className="font-default font-semibold text-foreground text-lg">
            {col.title}
          </h3>
          <ul className="flex flex-col gap-3">
            {col.links.map((link, j) => <li key={j} data-index={j}>
                <Link to={link.href} className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>)}
    </div>;
}
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
        {[1, 2, 3, 4, 5].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
            <div className="h-6 w-24 bg-muted animate-pulse rounded-md" />
            <div className="flex flex-col gap-3">
              <div className="h-4 w-32 bg-muted animate-pulse rounded-md" />
              <div className="h-4 w-28 bg-muted animate-pulse rounded-md" />
              <div className="h-4 w-36 bg-muted animate-pulse rounded-md" />
            </div>
          </div>)}
      </div>;
  }
  if (menuItems && menuItems.length > 0) {
    return <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-12">
        {menuItems.map((item, i) => <div key={item.id} data-index={i} className="flex flex-col gap-4">
            <h3 className="font-default font-semibold text-foreground text-lg">
              {item.label}
            </h3>
            {item.children && item.children.length > 0 && <ul className="flex flex-col gap-3">
                {item.children.map((child, j) => <li key={child.id} data-index={j}>
                    <Link to={child.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm">
                      {child.label}
                    </Link>
                  </li>)}
              </ul>}
          </div>)}
      </div>;
  }
  return <FallbackMenu />;
}
export default function FooterInformativo() {
  const socials = [{
    icon: Facebook,
    href: "#"
  }, {
    icon: Youtube,
    href: "#"
  }, {
    icon: Instagram,
    href: "#"
  }, {
    icon: Twitter,
    href: "#"
  }, {
    icon: Linkedin,
    href: "#"
  }];
  return <section id="footer-informativo" className="bg-background text-foreground pt-20 pb-10 px-4 md:px-8 border-t border-border">
      <div className="max-w-7xl mx-auto flex flex-col gap-16">
        {}
        <div className="bg-card rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center justify-between gap-8 border border-border shadow-sm">
          <h2 className="font-default text-2xl md:text-3xl lg:text-4xl font-bold max-w-2xl text-center lg:text-left leading-tight">
            Monitoraggio 24/7 collegato alle Forze dell'Ordine
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto shrink-0">
            <Button asChild size="lg" className="w-full sm:w-auto rounded-lg">
              <Link to="#">Inizia ora</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-lg">
              <Link to="#">Parla con un esperto</Link>
            </Button>
          </div>
        </div>

        {}
        <MenuProvider menu_id="23">
          <FooterMenuConsumer />
        </MenuProvider>

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
            <Link to="/">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="text-sm text-muted-foreground text-center md:text-left">
              &copy; {new Date().getFullYear()} Secureasy. Tutti i diritti riservati.
            </p>
          </div>

          <div className="flex items-center gap-6">
            {}
            <div className="flex items-center gap-4">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <span key={i} data-index={i}>
                    <Link to={social.href} className="text-muted-foreground hover:text-primary transition-colors" aria-label={`Social link ${i + 1}`}>
                      <Icon className="size-5" />
                    </Link>
                  </span>;
            })}
            </div>

            {}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="sm" className="gap-2 text-muted-foreground hover:text-foreground">
                  <Globe className="size-4" /> IT
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem>Italiano</DropdownMenuItem>
                <DropdownMenuItem>English</DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </div>
    </section>;
}